import { render, staticRenderFns } from "./adminMenu.vue?vue&type=template&id=1bc333a8&scoped=true&"
import script from "./adminMenu.vue?vue&type=script&lang=js&"
export * from "./adminMenu.vue?vue&type=script&lang=js&"
import style0 from "./adminMenu.vue?vue&type=style&index=0&id=1bc333a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc333a8",
  null
  
)

export default component.exports